var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2162_3166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9003 5.00024C11.1287 6.12089 10.9659 7.28595 10.4392 8.30114C9.91255 9.31632 9.05375 10.1203 8.00606 10.5789C6.95837 11.0375 5.78512 11.1231 4.68196 10.8214C3.57879 10.5197 2.6124 9.84894 1.94394 8.92095C1.27549 7.99296 0.945367 6.86386 1.00864 5.72193C1.07191 4.58001 1.52475 3.49428 2.29163 2.64582C3.05852 1.79736 4.0931 1.23745 5.22284 1.05947C6.35258 0.881477 7.5092 1.09617 8.49981 1.66774",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5L6 7L11 2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2162_3166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.3cb50a4a3f615d91ba7185fd0dd09dca.svg";
export { ForwardRef as ReactComponent };